const locale = {
	ORDERS_PLANNED_VALUE: 'Planned price: {value}',
	ORDERS_PLANNED_EXPENSES: 'Planned expenses: {value}',
	ORDERS_BILLED_VALUE: 'Billed: {value}',
	ORDERS_BILLED_EXPENSES: 'Expenses: {value}',
	ORDERS_BILLED_VALUE_MISSING: 'Billed: {value} (missing {missingValue})',
	ORDERS_BILLED_EXPENSES_MISSING: 'Expenses: {value} (missing {missingValue})',
	ORDERS_BILLED_PROFIT: 'Profit: {value}',

	ERROR_DELIVERY_DATE_REQUESTED_MIN_VALUE: 'The date must be after the order date',

	DETAILS_HEADER_BUTTON_ORDERS_CREATE_REVISION: 'Create revision',
	DETAILS_HEADER_BUTTON_ORDERS_PUSH_TO_NAV: 'Send to headquarters',
	DETAILS_HEADER_BUTTON_ORDERS_EXPORT_PDF_IT: 'Download IT PDF report',
	DETAILS_HEADER_BUTTON_ORDERS_EXPORT_PDF_EN: 'Download EN PDF report',
	DETAILS_HEADER_BUTTON_ORDERS_EXPORT_XLSX: 'Download Excel report',

	ORDERS_DIALOG_TITLE_ADD_OPPORTUNITY: 'Do you want to add a new Opportunity?',

	// #region Orders fields
	DETAILS_ORDERS_FIELD_TITLE: 'Title',
	DETAILS_ORDERS_FIELD_STATUS: 'Order Status',
	DETAILS_ORDERS_FIELD_TYPE: 'Order Type',
	// DETAILS_ORDERS_FIELD_TITLE: 'NAV code',
	// DETAILS_ORDERS_FIELD_STATUS: 'Order Status',
	// DETAILS_ORDERS_FIELD_TYPE: 'Order Type',
	DETAILS_ORDERS_FIELD_COMPANY: 'Customer Company',
	DETAILS_ORDERS_FIELD_PERSON: 'External Reference',
	DETAILS_ORDERS_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_ORDERS_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_ORDERS_FIELD_SIGNDATE: 'Date',
	DETAILS_ORDERS_FIELD_RATING: 'Rating',
	DETAILS_ORDERS_FIELD_TOT_TAX_EXCL: 'Total value (tax excluded)',
	DETAILS_ORDERS_FIELD_TOT_EXPENSES: 'Total expenses',
	DETAILS_ORDERS_FIELD_TAGS: 'Tags',
	DETAILS_ORDERS_FIELD_WARNING: 'Warning',
	DETAILS_ORDERS_FIELD_BLOCKED: 'Blocked',

	DETAILS_ORDERS_FIELD_PRICINGGROUP: 'Pricing group',
	DETAILS_ORDERS_FIELD_DISCOUNTGROUP: 'Discount group',
	DETAILS_ORDERS_FIELD_PAYMENTTERMS: 'Payment terms',
	DETAILS_ORDERS_FIELD_PAYMENTMETHOD: 'Payment method',
	DETAILS_ORDERS_FIELD_SHIPPINGMETHOD: 'Shipping method',
	DETAILS_ORDERS_FIELD_SHIPPINGAGENT: 'Shipping agent',
	DETAILS_ORDERS_FIELD_EXTERNAL_NUMBER: 'External number',
	DETAILS_ORDERS_FIELD_DATE_DATE_REQDELIVERY: 'Requested delivery date',
	// #endregion

	// #region Orders Lines
	DETAILS_ORDERS_LINES_FIELD_ORDER_STATUS: 'Order Status',
	DETAILS_ORDERS_LINES_FIELD_ERP_ID: 'ERP Code',
	// DETAILS_ORDERS_LINES_FIELD_ERP_ID: 'NAV Code',
	DETAILS_ORDERS_LINES_FIELD_TYPE: 'Type',
	DETAILS_ORDERS_LINES_FIELD_TYPE_ITEM: 'Item',
	DETAILS_ORDERS_LINES_FIELD_TYPE_WORKREPORTS: 'Service',
	DETAILS_ORDERS_LINES_FIELD_TYPE_NOTE: 'Note',
	DETAILS_ORDERS_LINES_FIELD_DESCRIPTION: 'Description',
	DETAILS_ORDERS_LINES_FIELD_ORDER: 'Order',
	DETAILS_ORDERS_LINES_FIELD_ITEM: 'Item',
	DETAILS_ORDERS_LINES_FIELD_SERVICE_TYPE: 'Service type',
	DETAILS_ORDERS_LINES_FIELD_ITEM_SERIES: 'Series',
	DETAILS_ORDERS_LINES_FIELD_ITEM_MEASURES: 'Measures',
	DETAILS_ORDERS_LINES_FIELD_BASE_PRICE: 'Base price',
	DETAILS_ORDERS_LINES_FIELD_DISCOUNT: 'Discount',
	DETAILS_ORDERS_LINES_FIELD_UNIT_PRICE: 'Unit price',
	DETAILS_ORDERS_LINES_FIELD_QUANTITY: 'Quantity',
	DETAILS_ORDERS_LINES_FIELD_ISCUSTOM: 'Custom price',
	DETAILS_ORDERS_LINES_FIELD_ITEM_UNITOFMEASURE: 'UM',
	DETAILS_ORDERS_LINES_FIELD_TOT_TAX_EXCL: 'Total price (tax excluded)',
	DETAILS_ORDERS_LINES_FIELD_UNIT_EXPENSES: 'Unit expenses (planned)',
	DETAILS_ORDERS_LINES_FIELD_TOT_EXPENSES: 'Total expenses (planned)',
	DETAILS_ORDERS_LINES_FIELD_PROJECT: 'Linked Project',
	DETAILS_ORDERS_LINES_FIELD_MERCHPOINTS: 'Merch Points',

	DETAILS_ORDERS_LINES_ORIGINAL_VALUE: 'Default value: {value}',

	DETAILS_ORDERS_LINES_FIELD_ERROR_OUTDATED_PRICE: 'Outdated price',
	DETAILS_ORDERS_LINES_FIELD_ERROR_UNAVAILABLE: 'Item not available',

	DETAILS_ORDERS_LINES_BUTTON_ADD_ITEM: 'Add Item',
	DETAILS_ORDERS_LINES_BUTTON_ADD_PRICING_ITEMS: 'Add Items from Pricing',
	DETAILS_ORDERS_LINES_BUTTON_ADD_SERVICE: 'Add Service',
	DETAILS_ORDERS_LINES_BUTTON_ADD_NOTE: 'Add Note',
	DETAILS_ORDERS_LINES_BUTTON_ADD_STANDARD_NOTES: 'Add Standard Notes',
	DETAILS_ORDERS_LINES_BUTTON_ADD_PROJECT: 'Create Project',
	DETAILS_ORDERS_LINES_BUTTON_ADD_INVOICE: 'Create Invoice',
	DETAILS_ORDERS_LINES_BUTTON_DELETE_LINE: 'Delete rows',

	DIALOG_ORDERS_LINES_DIALOG_ADD_TITLE: 'Add row',
	DIALOG_ORDERS_LINES_DIALOG_ADD_ITEMS_TITLE: 'Select the Items to add',
	DIALOG_ORDERS_LINES_DIALOG_ADD_NOTE_TITLE: 'Add Note',
	DIALOG_ORDERS_LINES_DIALOG_EDIT_TITLE: 'Edit row',

	DETAILS_ORDERS_LINES_LOTS_MIN_QTY: 'Minimum quantity',
	DETAILS_ORDERS_LINES_LOTS_UNIT_PRICE: 'Unit price',

	ORDERS_LINES_EDIT_DIALOG_PRICE_SECTION: 'Price',
	ORDERS_LINES_EDIT_DIALOG_EXPENSES_SECTION: 'Expense',
	ORDERS_LINES_EDIT_DIALOG_PROJECT_SECTION: 'Project',

	ORDERS_ACTION_EDIT_LINES: 'Edit',
	// #endregion

	// #region Orders Billing
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE: 'Billing schedule',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_DATE: 'Fixed date',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_SIGNED: 'Order sign',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_MILESTONE: 'Project milestone',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_MILESTONE_VALUE: 'Project - {value}',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_DATE_FINAL: 'Date',
	DETAILS_ORDERS_BILLING_FIELD_ORDER: 'Order',
	DETAILS_ORDERS_BILLING_FIELD_ORDER_LINE: 'Order Line',
	DETAILS_ORDERS_BILLING_FIELD_PROJECT: 'Project',
	DETAILS_ORDERS_BILLING_FIELD_COMPANY: 'Company',
	DETAILS_ORDERS_BILLING_FIELD_DESCRIPTION: 'Description',
	DETAILS_ORDERS_BILLING_FIELD_PAYMENTMETHOD: 'Payment Method',
	DETAILS_ORDERS_BILLING_FIELD_PAYMENTTERMS: 'Payment Terms',
	DETAILS_ORDERS_BILLING_FIELD_INVOICE_TYPE: 'Invoice Type',
	DETAILS_ORDERS_BILLING_FIELD_TYPE: 'Billing type',
	DETAILS_ORDERS_BILLING_FIELD_TYPE_QUANTITY: 'Quantity',
	DETAILS_ORDERS_BILLING_FIELD_TYPE_PERCENTAGE: 'Percentage',
	DETAILS_ORDERS_BILLING_FIELD_TYPE_AMOUNT: 'Amount',
	DETAILS_ORDERS_BILLING_FIELD_QUANTITY: 'Quantity',
	DETAILS_ORDERS_BILLING_FIELD_PERCENTAGE: 'Percentage',
	DETAILS_ORDERS_BILLING_FIELD_AMOUNT: 'Amount',
	DETAILS_ORDERS_BILLING_FIELD_BILLABLE: 'Billable',
	DETAILS_ORDERS_BILLING_FIELD_BILLED_DATE: 'Date billed',
	DETAILS_ORDERS_BILLING_FIELD_INVOICE: 'Invoice',

	DETAILS_ORDERS_BILLING_BUTTON_ADD_LINE: 'Add billing row',
	DETAILS_ORDERS_BILLING_BUTTON_DELETE_LINE: 'Delete billing rows',

	DIALOG_ORDERS_BILLING_DIALOG_ADD_TITLE: 'Add billing row',
	DIALOG_ORDERS_BILLING_DIALOG_EDIT_TITLE: 'Edit billing row',

	ORDERS_ACTION_EDIT_BILLING: 'Edit',
	// #endregion

	// #region Details Billing Company section
	DETAILS_BILLING_COMPANY_SECTION: 'Billing Address',
	DETAILS_BILLING_COMPANY_SUBHEADER: 'View the billing address',
	// #endregion

	// #region Details Shipping Company section
	DETAILS_SHIPPING_ADDRESS_SECTION: 'Shipping Address',
	DETAILS_SHIPPING_ADDRESS_SUBHEADER: 'View and edit the shipping address',
	// #endregion

	// #region Details Notes section
	DETAILS_NOTES_SECTION: 'Notes',
	DETAILS_NOTES_SUBHEADER: 'View and edit the delivery notes',
	// #endregion

	// #region Details Comments section
	DETAILS_COMMENTS_SECTION: 'Comments',
	DETAILS_COMMENTS_SUBHEADER: "View and edit the internal operator's comments",
	// #endregion

	// #region Details Check rows section
	ORDERS_DETAILS_CHECKROWS_TITLE: 'Detected change in price lists',
	ORDERS_DETAILS_CHECKROWS_TEXT1: 'Prices and/or availability of some Items have changed ',
	ORDERS_DETAILS_CHECKROWS_TEXT2: 'click "Update prices" to recalculate them',
	ORDERS_DETAILS_CHECKROWS_ACTION: 'Update prices',
	ORDERS_DETAILS_CHECKROWS_DIALOG: 'Are you sure you want to recalculate prices?',
	// #endregion

	// #region Orders general stats section
	ORDS_SECTION_BILLING_STATS_TITLE: 'Order stats',

	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED: 'Planned value',
	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED_INVOICES: 'by Items',
	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED_WORKREPORTS: 'by Workreports',
	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED_OTHER: 'by other',
	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED_MISSING: 'to be billed',

	ORDS_SECTION_BILLING_STATS_VALUE_FINAL: 'Current value',

	ORDS_SECTION_BILLING_STATS_EXPENSES_PLANNED_TOTAL: 'Planned expenses',
	ORDS_SECTION_BILLING_STATS_EXPENSES_PLANNED_INVOICES: 'by Invoices',
	ORDS_SECTION_BILLING_STATS_EXPENSES_PLANNED_WORKREPORTS: 'by Workreports',
	ORDS_SECTION_BILLING_STATS_EXPENSES_PLANNED_MISSING: 'to be billed',

	ORDS_SECTION_BILLING_STATS_EXPENSES_TOTAL: 'Current expenses',
	ORDS_SECTION_BILLING_STATS_EXPENSES_INVOICES: 'by Invoices',
	ORDS_SECTION_BILLING_STATS_EXPENSES_WORKREPORTS: 'by Workreports',
	ORDS_SECTION_BILLING_STATS_EXPENSES_OTHER: 'by other',

	ORDS_SECTION_BILLING_STATS_PROFIT_PLANNED: 'Planned profit',
	ORDS_SECTION_BILLING_STATS_PROFIT_PLANNED_INVOICES: 'by Items',
	ORDS_SECTION_BILLING_STATS_PROFIT_PLANNED_WORKREPORTS: 'by Services',
	ORDS_SECTION_BILLING_STATS_PROFIT_FINAL: 'Current profit',

	// #region Orders Min Value section
	ORDERS_MIN_VALUE_SECTION_TITLE: 'Minimum order value: {value}',
	ORDERS_MIN_VALUE_SECTION_PROGRESS: 'Only {value} left to be able to confirm your order',

	ORDERS_MIN_VALUE_ERROR: 'Minimum order value not reached',
	// #endregion

	// #region Orders Shipping charges
	ORDERS_SHIPPINGCHARGES_SECTION_TITLE: 'Shipping charges: {value}',
	ORDERS_SHIPPINGCHARGES_SECTION_SUBTITLE: 'Destination country: {country}',
	ORDERS_SHIPPINGCHARGES_SECTION_PROGRESS: 'Only {value} left for free shipping',

	TAB_SHIPPINGCHARGES: 'Shipping charges',
	ORDERS_SHIPPINGCHARGES_ADD: 'Add Shipping charges',
	ORDERS_SHIPPINGCHARGES_UPDATE: 'Edit Shipping charges',

	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_COUNTRY: 'Country',
	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_VALUE: 'Charges',
	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_TOT_VALUE_FROM: 'Taxable min. value',
	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_TOT_VALUE_TO: 'Taxable max. value',
	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_DISABLED: 'Disabled',
	// #endregion

	// #region Orders Merch Points
	ORDERS_MERCHPOINTS_SECTION_TITLE: 'Merch points spent:',
	DIALOG_ORDERS_MERCH_ADD_TITLE: 'Select Merchandise',
	DIALOG_ORDERS_MERCH_TABLE_FOOTER: 'Merchandise Points: {spent}/{earned}',

	ORDERS_MERCHPOINTS_ERROR: 'You have spent more Merch Points than are available!',

	DETAILS_ORDERS_MERCH_FIELD_ERP_ID: 'NAV Code',
	DETAILS_ORDERS_MERCH_FIELD_ITEM: 'Item',
	DETAILS_ORDERS_MERCH_FIELD_QUANTITY: 'Quantity',
	DETAILS_ORDERS_MERCH_FIELD_UNIT_PRICE: 'Unit points',
	DETAILS_ORDERS_MERCH_FIELD_TOT_PRICE: 'Total points',
	// #endregion

	// #region Orders Promos
	ORDERS_PROMOS_GROUP_ITEM_TITLE: 'Min taxable: {value}',
	ORDERS_PROMOS_GROUP_ITEM_TITLE2: 'Max taxable: {value}',
	ORDERS_PROMOS_GROUP_ITEM_SUBHEADER: '{value} left',
	ORDERS_PROMOS_TYPE_DISCOUNT_LABEL: 'Extra discount +{value}',

	TAB_PROMOS: 'Promos',
	ORDERS_PROMOS_ADD: 'Add Promo',
	ORDERS_PROMOS_ADD_ROW: 'Add row',

	ORDERS_PROMOS_TYPE_ITEMS: 'Free Items',
	ORDERS_PROMOS_TYPE_DISCOUNTS: 'Additional discount',
	ORDERS_PROMOS_TYPE_NOTES: 'Notes',

	DETAILS_ORDERS_PROMOS_FIELD_TITLE: 'Title',
	DETAILS_ORDERS_PROMOS_FIELD_DESCRIPTION: 'Description',
	DETAILS_ORDERS_PROMOS_FIELD_DATE_FROM: 'Date from',
	DETAILS_ORDERS_PROMOS_FIELD_DATE_TO: 'Date to',
	DETAILS_ORDERS_PROMOS_FIELD_TYPE: 'Type',
	DETAILS_ORDERS_PROMOS_FIELD_DISABLED: 'Disabled',
	DETAILS_ORDERS_PROMOS_FIELD_EXPIRED: 'Expired',

	DETAILS_ORDERS_PROMOS_FIELD_ACTIVE: 'Active',

	ORDERS_PROMOS_ROWS_COLUMN_ITEM: 'Item',
	ORDERS_PROMOS_ROWS_COLUMN_QUANTITY: 'Quantity',
	ORDERS_PROMOS_ROWS_COLUMN_DISCOUNT: 'Discount',
	ORDERS_PROMOS_ROWS_COLUMN_NOTE: 'Note',
	ORDERS_PROMOS_ROWS_COLUMN_TOT_VALUE_FROM: 'Taxable min. value',
	ORDERS_PROMOS_ROWS_COLUMN_TOT_VALUE_TO: 'Taxable max. value',
	// #endregion

	// #region Orders Standard Notes
	TAB_STANDARDNOTES: 'Standard Notes',
	ORDERS_STANDARDNOTES_ADD: 'Add Standard Note',
	ORDERS_STANDARDNOTES_ADD_ROW: 'Add row',

	DETAILS_ORDERS_STANDARDNOTES_FIELD_TITLE: 'Title',

	ORDERS_STANDARDNOTES_ROWS_COLUMN_DESCRIPTION: 'Description',
	ORDERS_STANDARDNOTES_ROWS_COLUMN_ORDER: 'Order'
	// #endregion
};

export default locale;
